import React from 'react'
import { Link } from '@reach/router'
import Page from './Page'

export default () =>
  <Page title='Welcome'>
    <Link to='/dashboard'>dashboard</Link>
  </Page>
